import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { selectAllDataByEnterprise } from "../../api/auth";
import baseUrl from "@/api/baseUrl";
export default {
  data: function data() {
    return {
      showLog: false,
      expandedItems: {},
      // 用于存储每个一级节点的展开状态
      expandedChildItems: {},
      // 用于存储每个二级节点的展开状态
      searchForm: {
        name: '',
        //名字
        enterpriseCode: '',
        page: 1,
        pageSize: 1000
      },
      tree: [{
        id: 1,
        label: "市场主体登记信息",
        children: [{
          id: 2,
          label: "市场主体登记信息",
          englishName: 'registration_info'
        }]
      }, {
        id: 3,
        label: "纳税信息",
        children: [{
          id: 5,
          label: "非正常纳税户信息",
          englishName: 'abnormal_taxpayer_info'
        }, {
          id: 11,
          label: "财务申报信息",
          englishName: 'financial_reporting_info'
        }, {
          id: 14,
          label: "增值税缴税信息",
          englishName: 'vat_payment_info'
        }, {
          id: 15,
          label: "企业所得税缴税信息",
          englishName: 'corporate_income_tax_info'
        }, {
          id: 16,
          label: "纳税信用等级A级信息",
          englishName: 'class_a_taxpayer_info'
        }, {
          id: 9,
          label: "企业缓税信息",
          englishName: 'tax_deferral_info'
        }, {
          id: 129,
          label: "历史欠税信息",
          englishName: 'historical_tax_arrears_info'
        }]
      }, {
        id: 81,
        label: "司法信息",
        children: [{
          id: 82,
          label: "省高院开庭信息",
          englishName: 'court_hearing_info'
        }, {
          id: 83,
          label: "省高院失信限制高消费信息",
          englishName: 'court_dishonesty_info'
        }, {
          id: 85,
          label: "法院判决信息",
          englishName: 'court_judgment_info'
        }, {
          id: 86,
          label: "破产案件信息",
          englishName: 'bankruptcy_case_info'
        }, {
          id: 87,
          label: "终结本次执行案件信息",
          englishName: 'execution_case_info'
        }]
      }, {
        id: 68,
        label: "进出口信息",
        children: [// { id: 69, label: "基础信息",englishName:'enterprise_basic_info'  },
        {
          id: 71,
          label: "海关注册信息",
          englishName: 'customs_registration_info'
        }, {
          id: 72,
          label: "海关信用等级信息",
          englishName: 'customs_credit_rating_info'
        }, {
          id: 70,
          label: "企业海关税款缴纳信息",
          englishName: 'customs_tax_payment_info'
        }]
      }, {
        id: 73,
        label: "生态环境领域信息",
        children: [// { id: 74, label: "碳排放信息",englishName:'carbon_emission_info'  },
        {
          id: 75,
          label: "环评信用信息",
          englishName: 'environmental_credit_info'
        }]
      }, {
        id: 34,
        label: "社会保险信息",
        children: [{
          id: 21,
          label: "企业职工基本养老保险缴费信息",
          englishName: 'pension_insurance_payment_info'
        }, {
          id: 23,
          label: "职工医疗保险费基本信息",
          englishName: 'employee_medical_insurance_info'
        }, {
          id: 24,
          label: "职工医疗保险费欠缴信息",
          englishName: 'employee_medical_insurance_arrears'
        }, {
          id: 25,
          label: "职工医疗保险费变动信息",
          englishName: 'employee_medical_insurance_change'
        }, {
          id: 19,
          label: "社会保险费缴纳情况",
          englishName: 'social_insurance_payment_info'
        }, {
          id: 20,
          label: "社会保险费欠缴信息",
          englishName: 'social_insurance_arrears_interface'
        }]
      }, {
        id: 62,
        label: "知识产权信息",
        children: [{
          id: 64,
          label: "企业商标信息",
          englishName: 'enterprise_trademark_info'
        }, {
          id: 66,
          label: "软件著作权信息",
          englishName: 'software_copyright_info'
        }, {
          id: 67,
          label: "专利商标质押信息",
          englishName: 'patent_pledge_info'
        }, // { id: 65, label: "专利信息",englishName:'enterprise_patent_info'  },
        {
          id: 63,
          label: "省高院知识产权涉诉信息",
          englishName: 'court_intellectual_property_info'
        }]
      }, {
        id: 33,
        label: "不动产登记信息",
        children: [{
          id: 28,
          label: "企业主名下不动产登记信息",
          englishName: 'enterprise_real_estate_info'
        }, {
          id: 29,
          label: "企业主名下不动产抵押信息",
          englishName: 'enterprise_real_estate_mortgage'
        }]
      }, {
        id: 46,
        label: "科技研发信息",
        children: [{
          id: 47,
          label: "科技研发信息",
          englishName: 'technology_rd_info'
        }]
      }, {
        id: 49,
        label: "新型农业经营主体信息",
        children: [{
          id: 51,
          label: "基本信息",
          englishName: 'agricultural_basic_info'
        }, {
          id: 52,
          label: "经营信息",
          englishName: 'agricultural_operation_info'
        }, {
          id: 54,
          label: "保险信息",
          englishName: 'agricultural_insurance_info'
        }, {
          id: 55,
          label: "补贴信息",
          englishName: 'agricultural_subsidy_info'
        }]
      }, {
        id: 200,
        label: "涉农类清单信息",
        children: [{
          id: 201,
          label: "涉农类清单信息",
          englishName: 'agricultural_list_info'
        }]
      }, {
        id: 59,
        label: "资质信息",
        children: [{
          id: 60,
          label: "行政许可信息",
          englishName: 'administrative_license_info'
        }]
      }, {
        id: 76,
        label: "医保定点信息",
        children: [{
          id: 77,
          label: "医保定点单位信息",
          englishName: 'medical_insurance_unit_info'
        }, {
          id: 78,
          label: "医保定点民营医疗机构信息",
          englishName: 'private_medical_insurance_info'
        }]
      }, {
        id: 36,
        label: "水电气费缴纳信息",
        children: [{
          id: 37,
          label: "水费信息",
          englishName: 'water_fee_info'
        }, {
          id: 38,
          label: "电费信息",
          englishName: 'electricity_fee_info'
        }, {
          id: 39,
          label: "燃气费信息",
          englishName: 'gas_fee_info'
        }]
      }, {
        id: 89,
        label: "企业行政处罚信息",
        children: [{
          id: 91,
          label: "企业行政处罚信息",
          englishName: 'administrative_punishment_info'
        }]
      }, {
        id: 205,
        label: "企业行政强制信息",
        children: [{
          id: 92,
          label: "企业行政强制信息",
          englishName: 'administrative_force_info'
        }]
      }, {
        id: 206,
        label: "企业黑名单信息",
        children: [{
          id: 93,
          label: "企业黑名单信息",
          englishName: 'blacklist_info'
        }]
      }, {
        id: 207,
        label: "自然人黑名单接口",
        children: [{
          id: 208,
          label: "自然人黑名单接口",
          englishName: 'person_black_info'
        }]
      }, {
        id: 35,
        label: "住房公积金缴纳情况",
        children: [{
          id: 17,
          label: "住房公积金缴纳情况",
          englishName: 'housing_fund_payment_info'
        }]
      }, {
        id: 100,
        label: "企业公共信用评价",
        children: [{
          id: 101,
          label: "企业公共信用评价",
          englishName: 'enterprise_zhdf'
        }]
      }],
      tree2: [{
        id: 1,
        label: "市场主体登记信息",
        children: [{
          id: 2,
          label: "市场主体登记信息",
          englishName: 'registration_info'
        }]
      }, {
        id: 3,
        label: "纳税信息",
        children: [{
          id: 5,
          label: "非正常纳税户信息",
          englishName: 'abnormal_taxpayer_info'
        }, {
          id: 11,
          label: "财务申报信息",
          englishName: 'financial_reporting_info'
        }, {
          id: 14,
          label: "增值税缴税信息",
          englishName: 'vat_payment_info'
        }, {
          id: 15,
          label: "企业所得税缴税信息",
          englishName: 'corporate_income_tax_info'
        }, {
          id: 16,
          label: "纳税信用等级A级信息",
          englishName: 'class_a_taxpayer_info'
        }, {
          id: 9,
          label: "企业缓税信息",
          englishName: 'tax_deferral_info'
        }, {
          id: 129,
          label: "历史欠税信息",
          englishName: 'historical_tax_arrears_info'
        }]
      }, {
        id: 81,
        label: "司法信息",
        children: [{
          id: 82,
          label: "省高院开庭信息",
          englishName: 'court_hearing_info'
        }, {
          id: 83,
          label: "省高院失信限制高消费信息",
          englishName: 'court_dishonesty_info'
        }, {
          id: 85,
          label: "法院判决信息",
          englishName: 'court_judgment_info'
        }, {
          id: 86,
          label: "破产案件信息",
          englishName: 'bankruptcy_case_info'
        }, {
          id: 87,
          label: "终结本次执行案件信息",
          englishName: 'execution_case_info'
        }]
      }, {
        id: 68,
        label: "进出口信息",
        children: [// { id: 69, label: "基础信息",englishName:'enterprise_basic_info'  },
        {
          id: 71,
          label: "海关注册信息",
          englishName: 'customs_registration_info'
        }, {
          id: 72,
          label: "海关信用等级信息",
          englishName: 'customs_credit_rating_info'
        }, {
          id: 70,
          label: "企业海关税款缴纳信息",
          englishName: 'customs_tax_payment_info'
        }]
      }, {
        id: 73,
        label: "生态环境领域信息",
        children: [// { id: 74, label: "碳排放信息",englishName:'carbon_emission_info'  },
        {
          id: 75,
          label: "环评信用信息",
          englishName: 'environmental_credit_info'
        }]
      }, {
        id: 34,
        label: "社会保险信息",
        children: [{
          id: 21,
          label: "企业职工基本养老保险缴费信息",
          englishName: 'pension_insurance_payment_info'
        }, {
          id: 23,
          label: "职工医疗保险费基本信息",
          englishName: 'employee_medical_insurance_info'
        }, {
          id: 24,
          label: "职工医疗保险费欠缴信息",
          englishName: 'employee_medical_insurance_arrears'
        }, {
          id: 25,
          label: "职工医疗保险费变动信息",
          englishName: 'employee_medical_insurance_change'
        }, {
          id: 19,
          label: "社会保险费缴纳情况",
          englishName: 'social_insurance_payment_info'
        }, {
          id: 20,
          label: "社会保险费欠缴信息",
          englishName: 'social_insurance_arrears_interface'
        }]
      }, {
        id: 62,
        label: "知识产权信息",
        children: [{
          id: 64,
          label: "企业商标信息",
          englishName: 'enterprise_trademark_info'
        }, {
          id: 66,
          label: "软件著作权信息",
          englishName: 'software_copyright_info'
        }, {
          id: 67,
          label: "专利商标质押信息",
          englishName: 'patent_pledge_info'
        }, // { id: 65, label: "专利信息",englishName:'enterprise_patent_info'  },
        {
          id: 63,
          label: "省高院知识产权涉诉信息",
          englishName: 'court_intellectual_property_info'
        }]
      }, {
        id: 33,
        label: "不动产登记信息",
        children: [{
          id: 28,
          label: "企业主名下不动产登记信息",
          englishName: 'enterprise_real_estate_info'
        }, {
          id: 29,
          label: "企业主名下不动产抵押信息",
          englishName: 'enterprise_real_estate_mortgage'
        }]
      }, {
        id: 46,
        label: "科技研发信息",
        children: [{
          id: 47,
          label: "科技研发信息",
          englishName: 'technology_rd_info'
        }]
      }, {
        id: 49,
        label: "新型农业经营主体信息",
        children: [{
          id: 51,
          label: "基本信息",
          englishName: 'agricultural_basic_info'
        }, {
          id: 52,
          label: "经营信息",
          englishName: 'agricultural_operation_info'
        }, {
          id: 54,
          label: "保险信息",
          englishName: 'agricultural_insurance_info'
        }, {
          id: 55,
          label: "补贴信息",
          englishName: 'agricultural_subsidy_info'
        }]
      }, {
        id: 200,
        label: "涉农类清单信息",
        children: [{
          id: 201,
          label: "涉农类清单信息",
          englishName: 'agricultural_list_info'
        }]
      }, {
        id: 59,
        label: "资质信息",
        children: [{
          id: 60,
          label: "行政许可信息",
          englishName: 'administrative_license_info'
        }]
      }, {
        id: 76,
        label: "医保定点信息",
        children: [{
          id: 77,
          label: "医保定点单位信息",
          englishName: 'medical_insurance_unit_info'
        }, {
          id: 78,
          label: "医保定点民营医疗机构信息",
          englishName: 'private_medical_insurance_info'
        }]
      }, {
        id: 36,
        label: "水电气费缴纳信息",
        children: [{
          id: 37,
          label: "水费信息",
          englishName: 'water_fee_info'
        }, {
          id: 38,
          label: "电费信息",
          englishName: 'electricity_fee_info'
        }, {
          id: 39,
          label: "燃气费信息",
          englishName: 'gas_fee_info'
        }]
      }, {
        id: 89,
        label: "企业行政处罚信息",
        children: [{
          id: 91,
          label: "企业行政处罚信息",
          englishName: 'administrative_punishment_info'
        }]
      }, {
        id: 205,
        label: "企业行政强制信息",
        children: [{
          id: 92,
          label: "企业行政强制信息",
          englishName: 'administrative_force_info'
        }]
      }, {
        id: 206,
        label: "企业黑名单信息",
        children: [{
          id: 93,
          label: "企业黑名单信息",
          englishName: 'blacklist_info'
        }]
      }, {
        id: 207,
        label: "自然人黑名单接口",
        children: [{
          id: 208,
          label: "自然人黑名单接口",
          englishName: 'person_black_info'
        }]
      }, {
        id: 35,
        label: "住房公积金缴纳情况",
        children: [{
          id: 17,
          label: "住房公积金缴纳情况",
          englishName: 'housing_fund_payment_info'
        }]
      }, {
        id: 100,
        label: "企业公共信用评价",
        children: [{
          id: 101,
          label: "企业公共信用评价",
          englishName: 'enterprise_zhdf'
        }]
      }],
      time: 0
    };
  },
  mounted: function mounted() {
    this.showLog = false;
    this.time = 0;
  },
  methods: {
    // 切换展开/折叠状态
    toggleExpand: function toggleExpand(id) {
      this.$set(this.expandedItems, id, !this.expandedItems[id]);
    },
    // 切换二级节点展开/折叠状态
    toggleExpandChild: function toggleExpandChild(parentId, childId) {
      var key = "".concat(parentId, "-").concat(childId);
      this.$set(this.expandedChildItems, key, !this.expandedChildItems[key]);
    },
    downJson: function downJson(e) {
      if (this.searchForm.enterpriseCode || this.searchForm.name) {
        var xhr = new XMLHttpRequest();
        xhr.open("get", baseUrl + "api/v1/queryData/downAllList" + '?page=' + this.searchForm.page + '&pageSize=' + this.searchForm.pageSize + '&name=' + this.searchForm.name + '&enterpriseCode=' + this.searchForm.enterpriseCode, true); // get、post都可

        xhr.responseType = "blob"; // 转换流

        xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对

        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

        xhr.onload = function () {
          if (this.status === 200) {
            var blob = this.response;
            var fileName = "授权书列表下载.xlsx";

            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              var a = document.createElement("a");
              var url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
            }
          }
        };

        xhr.send();
      } else {
        this.$message.warning("请输入统一社会信用代码或企业名称！");
      }
    },
    showOneTag: function showOneTag(item) {
      var flag = false;
      item.children.forEach(function (child) {
        if (child.children && child.children.length > 0) {
          flag = true;
        }
      });
      return flag;
    },
    // 搜索
    searchFunction: function searchFunction() {
      if (this.searchForm.enterpriseCode || this.searchForm.name) {
        this.selectAllDataByEnterpriseApi();
      } else {
        this.$message.warning("请输入统一社会信用代码或企业名称！");
      }
    },
    selectAllDataByEnterpriseApi: function () {
      var _selectAllDataByEnterpriseApi = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var res, _loop, key;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.tree = JSON.parse(JSON.stringify(this.tree2));
                this.expandedItems = {}; // 用于存储每个一级节点的展开状态

                this.expandedChildItems = {}; // 用于存储每个二级节点的展开状态

                _context.next = 5;
                return selectAllDataByEnterprise(this.searchForm);

              case 5:
                res = _context.sent;
                console.log(res.data, '1111111111');

                if (res.data.code == 202 && res.data.data == null) {
                  this.showLog = true;
                  this.time = 0;
                } else {
                  this.showLog = false;

                  _loop = function _loop(key) {
                    _this.tree.forEach(function (treeItem) {
                      treeItem.children.forEach(function (child) {
                        if (child.englishName === 'financial_reporting_info' && key === 'financial_reporting_info') {
                          console.log(22222222222222223333333333333333333);
                        }

                        if (child.englishName === key && res.data.data[key] && (res.data.data[key].length > 0 || res.data.data[key] !== null)) {
                          _this.$set(child, 'children', res.data.data[key]); // 默认展开二级节点


                          _this.$set(_this.expandedChildItems, "".concat(treeItem.id, "-").concat(child.id), true); // 默认展开一级节点


                          _this.$set(_this.expandedItems, treeItem.id, true);
                        }
                      });
                    });
                  };

                  for (key in res.data.data) {
                    _loop(key);
                  }

                  this.time = 1;
                  console.log(this.tree);
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function selectAllDataByEnterpriseApi() {
        return _selectAllDataByEnterpriseApi.apply(this, arguments);
      }

      return selectAllDataByEnterpriseApi;
    }()
  }
};